//TODO make this more modern

// export function stringToLatLng(str) {
//     var arr = str.split(',');
//     return new L.LatLng(parseFloat(arr[0]), parseFloat(arr[1]));
// }
//
// export function truncatedLatLng(latLngStr) {
//     var ll = stringToLatLng(latLngStr);
//     return Math.round(ll.lat * 100000) / 100000 + "," + Math.round(ll.lng * 100000) / 100000;
// }


export function decodePolyline(polyline) {

    var currentPosition = 0;

    var currentLat = 0;
    var currentLng = 0;

    var dataLength = polyline.length;

    var polylineLatLngs = [];

    while (currentPosition < dataLength) {

        var shift = 0;
        var result = 0;

        var byte;

        do {
            byte = polyline.charCodeAt(currentPosition++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        } while (byte >= 0x20);

        var deltaLat = ((result & 1) ? ~(result >> 1) : (result >> 1));
        currentLat += deltaLat;

        shift = 0;
        result = 0;

        do {
            byte = polyline.charCodeAt(currentPosition++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        } while (byte >= 0x20);

        var deltLng = ((result & 1) ? ~(result >> 1) : (result >> 1));

        currentLng += deltLng;
        polylineLatLngs.push([currentLat * 0.00001, currentLng * 0.00001]);
    }

    return polylineLatLngs;
}
//
// export function distanceString(m) {
//     if (otp.config.metric) {
//         return this.distanceStringMetric(m);
//     } else {
//         return this.distanceStringImperial(m);
//     }
// }
//
// export function distanceStringImperial(m) {
//     var ft = m * 3.28084;
//     if (ft < 528) return Math.round(ft) + ' feet';
//     return Math.round(ft / 528) / 10 + " miles";
// }
//
// export function distanceStringMetric(m) {
//     km = m / 1000;
//     if (km > 100) {
//         //100 km => 999999999 km
//         km = km.toFixed(0);
//         return km + " km";
//     } else if (km > 1) {
//         //1.1 km => 99.9 km
//         km = km.toFixed(1);
//         return km + " km";
//     } else {
//         //1m => 999m
//         m = m.toFixed(0);
//         return m + " m";
//     }
// }

